
import { Component, Prop, Vue } from 'vue-property-decorator'

import DeliveryAddressList from './DeliveryAddressList.vue'
import { EnrollmentForm } from '../types/enrollmentForm'
import { computePasswordStrength, PasswordStrength } from '../utils/passwordStrength'

@Component({
  name: 'StepStructure',
  components: { DeliveryAddressList }
})
export default class extends Vue {
  @Prop({ required: true }) form!: EnrollmentForm
  @Prop({ default: () => [] }) prefilledFields!: string[]
  @Prop({ default: false }) legalError!: boolean
  @Prop({ default: false }) planetbPrefilled!: boolean

  showPassword = false
  showPasswordConfirm = false
  passwordStrength: PasswordStrength = computePasswordStrength('')

  entityKinds = ['CSE', 'Entreprise', 'Association', 'Collectivité', 'Autre']
  contactRoles = ['Trésorier(e)', 'Secrétaire', 'Chef d\'entreprise', 'Responsable financier(e)', 'Responsable marketing', 'Autre']
  employeeRanges = [
    { value: '1-10', label: '1 – 10' },
    { value: '11-50', label: '11 – 50' },
    { value: '51-250', label: '51 – 250' },
    { value: '250+', label: '250+' }
  ]
  countries = [
    { value: 'FR', label: 'France' },
    { value: 'BE', label: 'Belgique' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'CH', label: 'Suisse' }
  ]

  get showContactRoleOther(): boolean {
    return this.form.contactRole === 'Autre' || !this.form.contactRole
  }

  get hasPrefilledAddresses(): boolean {
    return this.form.deliveryAddresses.some(a => a.prefilled)
  }

  get passwordMatchText(): string {
    if (!this.form.passwordConfirmation) return this.$t('enrollment.password.matchDefault') as string
    return this.form.password === this.form.passwordConfirmation
      ? this.$t('enrollment.password.matchOk') as string
      : this.$t('enrollment.password.matchKo') as string
  }

  get passwordMatchColor(): string {
    if (!this.form.passwordConfirmation) return '#909399'
    return this.form.password === this.form.passwordConfirmation ? '#059669' : '#DC2626'
  }

  isPrefilled(field: string): boolean {
    return this.prefilledFields.includes(field)
  }

  onPasswordInput(): void {
    this.passwordStrength = computePasswordStrength(this.form.password)
  }

  onPasswordConfirmInput(): void {
    // trigger re-render for match hint
  }
}
